import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import { LOGOUT_SUCCESS } from '@actions/appState';

import actionCenter from './actionCenter';
import agency from './agency';
import agencyPreferences from './agencyPreferences';
import apiCredential from './apiCredential';
import appState from './appState';
import auditTrail from './auditTrails';
import auth from './auth';
import broadcast from './broadcast';
import caseCustomTile from './caseCustomTile';
import caseListingVar from './caseListingVar';
import caseRole from './caseRole';
import category from './category';
import ceLibraryUrl from './ceLibraryUrl';
import chargeCode from './chargeCode';
import collection from './collection';
import configAction from './configAction';
import configPaymentIntegration from './configPayment';
import contact from './contact';
import contactCustomField from './contactCustomField';
import crm from './crm';
import dashboard from './dashboard';
import department from './department';
import emailTemplate from './emailTemplate';
import entitySection from './entitySection';
import executiveReports from './executiveReports';
import feePaymentCustomField from './feePaymentCustomField';
import financeReport from './financeReport';
import fine from './fine';
import finesSetup from './finesSetup';
import forcedAbatementActivity from './forcedAbatementActivity';
import form from './form';
import gis from './gis';
import group from './group';
import htmlFormImage from './htmlFormImage';
import locationCustomField from './locationCustomField';
import mergeCode from './mergeCode';
import mobileAppSettings from './mobileAppSettings';
import municipalCode from './municipalCode';
import notice from './notice';
import noticeFormSection from './noticeFormSection';
import paymentCollections from './paymentCollections';
import paymentPortal from './paymentPortal';
import paymentType from './paymentType';
import product from './product';
import productLayout from './productLayout';
import pushTemplate from './pushTemplate';
import role from './role';
import smsTemplate from './smsTemplate';
import submissionSettings from './submissionSettings';
import superAdmin from './superAdmin';
import systemEvent from './systemEvent';
import tag from './tag';
import transaction from './transaction';
import user from './user';
import violation from './violation';
import violationDisposition from './violationDisposition';
import violationEntity from './violationEntity';
import violationType from './violationType';
import webhook from './webhook';
import workSchedule from './workSchedule';
import workspace from './workspace';
import caseType from './xerCaseType';
import xerceCase from './xerceCase';
import xerceReports from './xerceReports';

const appReducers = (history) =>
  combineReducers<IReduxStore>({
    router: connectRouter(history),
    agency,
    appState,
    contact,
    entitySection,
    auth,
    broadcast,
    gis,
    product,
    user,
    municipalCode,
    violation,
    violationType,
    violationDisposition,
    caseType,
    caseRole,
    xerceCase,
    forcedAbatementActivity,
    fine,
    workSchedule,
    paymentType,
    superAdmin,
    contactCustomField,
    locationCustomField,
    productLayout,
    caseCustomTile,
    noticeFormSection,
    form,
    notice,
    htmlFormImage,
    feePaymentCustomField,
    dashboard,
    mergeCode,
    xerceReports,
    crm,
    category,
    emailTemplate,
    smsTemplate,
    pushTemplate,
    submissionSettings,
    mobileAppSettings,
    violationEntity,
    executiveReports,
    group,
    configAction,
    systemEvent,
    role,
    department,
    tag,
    auditTrail,
    webhook,
    apiCredential,
    transaction,
    finesSetup,
    paymentPortal,
    agencyPreferences,
    collection,
    paymentCollections,
    configPaymentIntegration,
    workspace,
    chargeCode,
    financeReport,
    ceLibraryUrl,
    caseListingVar,
    actionCenter,
  });

export const reducers = (history) => (state, action) => {
  let newState = Object.assign({}, state);

  switch (action.type) {
    case LOGOUT_SUCCESS:
      newState = undefined;
      break;
  }

  return appReducers(history)(newState, action);
};
